/**
 * Get a cookie value by name
 * @param {string} name   - cookie name
 * @returns {string|null} - cookie value or null if not found
 */
export const getCookie = (name) => {
  if (!name) return null;

  const decoded = decodeURIComponent(document.cookie || '');
  const cookies = decoded.split(';').map((cookie) => cookie.trim());

  const found = cookies.find((cookie) => cookie.startsWith(`${name}=`));
  return found ? found.substring(name.length + 1) : null;
};
